import { parseApiError, isApiErrorCode } from './parseApiError';
import type { AuthErrorCode, IAuthApiError } from './types';

export const parseAuthError = (error: unknown): IAuthApiError => {
  return parseApiError(error);
};

export const isAuthErrorCode = (error: unknown, code: AuthErrorCode): error is IAuthApiError => {
  return isApiErrorCode(error, code);
};
